// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
Object.defineProperties(Vue.prototype, {
  // 注册不同环境的HOST为vue的原型对象属性，名称为baseURL
  baseURL: {
    value: process.env.BASE_API,
    writable: false
  }
})

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
//下面是将$axios和$qs挂在原型上，以便在实例中能用 this.$axios能够拿到
import axios from 'axios'
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
// Vue.prototype.qs = qs  
import 'lib-flexible'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import animate from "animate.css";
Vue.use(animate)
import head from "./components/head";  // header
import headTail from "./components/headTail";  // head-tail
Vue.component("headBar", head);
Vue.component("headTail", headTail);
//注册'v-animate'  当元素出现在可视范围时添加类名触发动效样式
Vue.directive('animate', {
    inserted: function (el, binding) {
      // 聚焦元素
      binding.addClass = () => {
        const { top } = el.getBoundingClientRect()
        const h = document.documentElement.clientHeight || document.body.clientHeight
        if (top < h) {
          if(el.className.indexOf(binding.value) == -1 ){
            // 初次还未绑定过，则新增类名(注意：下面单引号中间是一个空格！！！)
            el.className = binding.value+' '+el.className
          }
          if (binding.addClass) {
            window.removeEventListener('scroll', binding.addClass)
          }
        }
      }
      window.addEventListener('scroll', binding.addClass,true)
      binding.addClass()
    },
    unbind: function (el, binding) {
      if (binding.addClass) {
        window.removeEventListener('scroll', binding.addClass)
      }
    }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js